import React, { useEffect, useState } from "react";
import "./employee.css";
import axios from "axios";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import CredentialsPopup from "../components/CredentialsPopup";
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import SaveIcon from '@mui/icons-material/Save';
import Button from '@mui/material/Button';
import Switch from '@mui/material/Switch';
import { message } from "antd";
import APIURL, { IMAGE_BASE_URL } from "../api/apiClient";
import Loader from "../components/Loader";




const EditEmployee = () => {
    const [loading, setLoading] = useState(false);
    const { id } = useParams();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    // Extract credentials from URL
    const username = queryParams.get("username") || "";
    const employee_id = queryParams.get("employee_id") || "";
    const password = queryParams.get("password") || "";

    const [showCredentialsPopup, setShowCredentialsPopup] = useState(false);
    const [missingCredentials, setMissingCredentials] = useState(false);
    const [employeeList, setEmployeeList] = useState({
        title: '',
        first_name: '',
        middle_name: '',
        last_name: '',
        gender: '',
        username: '',
        employee_id: '',
        password: '',
        role: '',
        profile_image: '',
        profilePreview: '',
        email_id: '',
        joining_date: '',
        mobile_no: '',
        emergency_mobile_no: '',
        highest_qualification: '',
        date_of_birth: '',
        marital_status: '',
        blood_group: '',
        adhaar_number: '',
        bank_name: '',
        pan_number: '',
        aniversary_date: '',
        bank_account_number: '',
        bank_branch: '',
        ifsc_code: '',
        address: '',
        status: ''
    })


    const navigate = useNavigate();


    useEffect(() => {
        const fetchEmployee = async () => {
            setLoading(true);
            try {
                const response = await APIURL.get(`/fetchemployeeid.php?id=${id}`);
                console.log("API Response:", response);

                if (response.employee) {
                    const fetchedProfile = response.employee?.profile_image;

                    const employeeData = {
                        ...response.employee,
                        ...response.user,
                        profile_image: fetchedProfile
                            ? `${IMAGE_BASE_URL}${fetchedProfile}`
                            : employeeList.profile_image,

                        // Inject credentials from URL if available
                        username: username || response.user?.username,
                        employee_id: employee_id || response.user?.employee_id,
                        password: password || response.user?.password,
                    };

                    setEmployeeList(employeeData);

                    const credentialsMissing =
                        !employeeData.username || !employeeData.password_hash;

                    setMissingCredentials(credentialsMissing);

                    // Optionally auto-show popup if missing
                    // if (credentialsMissing) setShowCredentialsPopup(true);
                } else {
                    console.error(
                        "Error: ",
                        response.error || response.user_error || "Unknown error"
                    );
                }
            } catch (error) {
                console.error("Error fetching employee data:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchEmployee();
    }, [id]);

    const handleSaveCredentials = (credentials) => {
        console.log("Received credentials:", credentials);
        const updatedEmployee = {
            ...employeeList,
            username: credentials.username,
            employee_id: credentials.employee_id,
            password: credentials.password
        };
        setEmployeeList(updatedEmployee);
        setShowCredentialsPopup(false);
        setMissingCredentials(false);
    };



    const handleChange = (e) => {
        const { name, type, files, value, checked } = e.target;

        if (type === "checkbox") {
            setEmployeeList((prevEmployee) => ({
                ...prevEmployee,
                [name]: checked ? 1 : 0,
            }))
        } else if (type === 'file') {
            if (name === 'profile_image') {
                const profileFile = files[0];
                if (profileFile) {
                    // Revoke the previous URL to free memory
                    if (employeeList.profilePreview) {
                        URL.revokeObjectURL(employeeList.profilePreview);
                    }
                    const profilePreview = URL.createObjectURL(profileFile);
                    setEmployeeList((prevEmployee) => ({
                        ...prevEmployee,
                        profile_image: profileFile,
                        profilePreview,
                    }));
                }
            }
        } else {
            setEmployeeList((prevEmployee) => ({
                ...prevEmployee,
                [name]: value,
            }));
        }
    }

    useEffect(() => {
        return () => {
            if (employeeList.profilePreview) {
                URL.revokeObjectURL(employeeList.profilePreview);
            }
        };
    }, [employeeList.profilePreview]);


    const handleUpdate = async (e) => {
        e.preventDefault();

        // console.log("Before submitting, employeeList:", employeeList);

        try {
            const formData = new FormData();

            // Append all fields
            Object.entries(employeeList).forEach(([field, value]) => {
                if (field === "profile_image" && value instanceof File) {
                    formData.append(field, value);
                } else if (value !== undefined && value !== null) {
                    formData.append(field, value);
                }
            });

            // Ensure ID is included
            formData.append("id", employeeList.id);

            // console.log("Form data being sent:", [...formData.entries()]);

            let response = await APIURL.post("/updateemployee.php", formData, true);
            // console.log("Raw response:", response);

            // If response is a string (not JSON), try to parse it
            if (typeof response === "string") {
                try {
                    response = JSON.parse(response.trim());
                } catch {
                    // fallback if not JSON
                    response = { success: false, message: response };
                }
            }

            // Handle success / error safely
            if (response.success) {
                message.success(response.message || "Record updated successfully");
                navigate("/employeemaster");
            } else {
                alert(`Form submission failed: ${response.error || response.message || "Unknown error"}`);
            }
        } catch (error) {
            console.error("Error submitting form:", error);
            alert(`Error: ${error.message || "Unknown error"}`);
        }
    };


    // ✅ Full screen loader while fetching
    if (loading) {
        return <Loader type="full" loading={loading} />;
    }

    return (
        <>
            {/* <Loader type="full" loading={loading} /> */}
            <div className="employee-master-container">
                <div className="card">
                    <div className="card-header text-white d-flex justify-content-between align-items-center"
                        style={{
                            background: 'linear-gradient(15deg, #667eea 0%, #764ba2 100%)',
                            padding: '1rem 1.5rem',
                            border: 'none'
                        }}>
                        <h2 className="mb-0" style={{
                            color: 'white',
                            textShadow: '0 1px 2px rgba(0,0,0,0.2)',
                            fontWeight: '600'
                        }}>
                            Employee Master
                        </h2>
                        {missingCredentials && (
                            <button
                                type="button"
                                onClick={() => setShowCredentialsPopup(true)}
                                style={{
                                    background: 'linear-gradient(15deg, #f6d365 0%, #fda085 100%)',
                                    border: 'none',
                                    color: '#333',
                                    padding: '0.5rem 1.25rem',
                                    borderRadius: '30px',
                                    fontWeight: '500',
                                    display: 'flex',
                                    alignItems: 'center',
                                    boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
                                    transition: 'all 0.3s ease'
                                }}
                                onMouseOver={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                                onMouseOut={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                            >
                                <i className="bi bi-key-fill me-2"></i>Set Employee Credentials
                            </button>
                        )}
                    </div>

                    <div className="card-body">
                        <form onSubmit={handleUpdate}>
                            {/* Profile image Section */}
                            <div className="border rounded col-md-4 p-1 mb-4">
                                <section className="profile-grid-container">
                                    <label htmlFor="profile_image" className="label_profile">
                                        Add <br /><span>Profile Image</span>
                                        <input
                                            type="file"
                                            name="profile_image"
                                            id="profile_image"
                                            className="profile"
                                            onChange={handleChange}
                                        />
                                    </label>
                                    <div className="profile_image">
                                        {(employeeList.profilePreview || employeeList.profile_image) && (
                                            <img
                                                src={
                                                    employeeList.profilePreview || // New upload (object URL)
                                                    employeeList.profile_image    // Fetched image (URL string)
                                                }
                                                alt="Profile"
                                                height={100}
                                                className="profile_img"
                                            />
                                        )}
                                    </div>
                                </section>
                            </div>

                            {/* Basic Information Section */}
                            <div className="border rounded p-4 mb-4">
                                <h5 className="mb-4 border-bottom pb-2">Basic Information</h5>
                                <div className="row">
                                    <div className="col-md-3 mb-3">
                                        <TextField
                                            select
                                            label="Title"
                                            size="small"
                                            fullWidth
                                            name="title"
                                            value={employeeList.title}
                                            onChange={handleChange}
                                        >
                                            <MenuItem value="" disabled>Select Title</MenuItem>
                                            <MenuItem value="mr">Mr.</MenuItem>
                                            <MenuItem value="ms">Ms.</MenuItem>
                                            <MenuItem value="mrs">Mrs.</MenuItem>
                                        </TextField>
                                    </div>

                                    <div className="col-md-3 mb-3">
                                        <TextField
                                            label="First Name"
                                            size="small"
                                            fullWidth
                                            name="first_name"
                                            placeholder="First Name"
                                            value={employeeList.first_name}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="col-md-3 mb-3">
                                        <TextField
                                            label="Middle Name"
                                            size="small"
                                            fullWidth
                                            name="middle_name"
                                            placeholder="Middle Name"
                                            value={employeeList.middle_name}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="col-md-3 mb-3">
                                        <TextField
                                            label="Last Name"
                                            size="small"
                                            fullWidth
                                            name="last_name"
                                            placeholder="Last Name"
                                            value={employeeList.last_name}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="col-md-4 mb-3">
                                        <TextField
                                            label="Email"
                                            size="small"
                                            fullWidth
                                            type="email"
                                            name="email_id"
                                            placeholder="Email"
                                            value={employeeList.email_id}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="col-md-4 mb-3">
                                        <TextField
                                            label="Mobile Number"
                                            size="small"
                                            fullWidth
                                            type="number"
                                            name="mobile_no"
                                            placeholder="Mobile Number"
                                            value={employeeList.mobile_no}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="col-md-4 mb-3">
                                        <TextField
                                            label="Emergency Mobile"
                                            size="small"
                                            fullWidth
                                            type="number"
                                            name="emergency_mobile_no"
                                            placeholder="Emergency Mobile"
                                            value={employeeList.emergency_mobile_no}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="col-md-4 mb-3">
                                        <div className="d-flex align-items-center">
                                            <span className="me-3 fw-bold">Designation:</span>
                                            <TextField
                                                select
                                                label="Designation"
                                                size="small"
                                                fullWidth
                                                name="role"
                                                value={employeeList.role}
                                                onChange={handleChange}
                                            >
                                                <MenuItem value='employee'>Employee</MenuItem>
                                                <MenuItem value='admin'>Admin</MenuItem>
                                                <MenuItem value="staff">Staff</MenuItem>
                                            </TextField>
                                        </div>
                                    </div>

                                    <div className="col-md-4 mb-3 d-flex align-items-center">
                                        <span className="me-3 fw-bold">Employee Status:</span>
                                        <Switch
                                            name="status"
                                            checked={employeeList.status}
                                            onChange={(e) => handleChange({ target: { name: 'status', type: 'checkbox', checked: e.target.checked } })}
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* Personal Details Section */}
                            <div className="border rounded p-4 mb-4">
                                <h5 className="mb-4 border-bottom pb-2">Personal Details</h5>
                                <div className="row">
                                    <div className="col-md-3 mb-3">
                                        <TextField
                                            label="Date of Birth"
                                            size="small"
                                            fullWidth
                                            type="date"
                                            name="date_of_birth"
                                            InputLabelProps={{ shrink: true }}
                                            value={employeeList.date_of_birth}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="col-md-3 mb-3">
                                        <TextField
                                            label="Anniversary Date"
                                            size="small"
                                            fullWidth
                                            type="date"
                                            name="aniversary_date"
                                            InputLabelProps={{ shrink: true }}
                                            value={employeeList.aniversary_date}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="col-md-3 mb-3">
                                        <TextField
                                            label="Highest Qualification"
                                            size="small"
                                            fullWidth
                                            name="highest_qualification"
                                            placeholder="Highest Qualification"
                                            value={employeeList.highest_qualification}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="col-md-3 mb-3">
                                        <TextField
                                            select
                                            label="Marital Status"
                                            size="small"
                                            fullWidth
                                            name="marital_status"
                                            value={employeeList.marital_status}
                                            onChange={handleChange}
                                        >
                                            <MenuItem value="" disabled>Marital Status</MenuItem>
                                            <MenuItem value="married">Married</MenuItem>
                                            <MenuItem value="unmarried">Unmarried</MenuItem>
                                        </TextField>
                                    </div>

                                    <div className="col-md-3 mb-3">
                                        <TextField
                                            label="Blood Group"
                                            size="small"
                                            fullWidth
                                            name="blood_group"
                                            placeholder="Blood Group"
                                            value={employeeList.blood_group}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="col-md-3 mb-3">
                                        <TextField
                                            select
                                            label="Gender"
                                            size="small"
                                            fullWidth
                                            name="gender"
                                            value={employeeList.gender}
                                            onChange={handleChange}
                                        >
                                            <MenuItem value="" disabled>Gender</MenuItem>
                                            <MenuItem value="male">Male</MenuItem>
                                            <MenuItem value="female">Female</MenuItem>
                                            <MenuItem value="other">Other</MenuItem>
                                        </TextField>
                                    </div>

                                    <div className="col-md-6 mb-3">
                                        <TextField
                                            label="Address"
                                            size="small"
                                            fullWidth
                                            multiline
                                            rows={2}
                                            name="address"
                                            placeholder="Address"
                                            value={employeeList.address}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* Employment Details Section */}
                            <div className="border rounded p-4 mb-4">
                                <h5 className="mb-4 border-bottom pb-2">Employment Details</h5>
                                <div className="row">
                                    <div className="col-md-3 mb-3">
                                        <TextField
                                            label="Joining Date"
                                            size="small"
                                            fullWidth
                                            type="date"
                                            name="joining_date"
                                            InputLabelProps={{ shrink: true }}
                                            value={employeeList.joining_date}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="col-md-3 mb-3">
                                        <TextField
                                            label="Bank Name"
                                            size="small"
                                            fullWidth
                                            name="bank_name"
                                            placeholder="Bank Name"
                                            value={employeeList.bank_name}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="col-md-3 mb-3">
                                        <TextField
                                            label="Bank Account Number"
                                            size="small"
                                            fullWidth
                                            name="bank_account_number"
                                            placeholder="Bank Account Number"
                                            value={employeeList.bank_account_number}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="col-md-3 mb-3">
                                        <TextField
                                            label="Bank Branch"
                                            size="small"
                                            fullWidth
                                            name="bank_branch"
                                            placeholder="Bank Branch"
                                            value={employeeList.bank_branch}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="col-md-3 mb-3">
                                        <TextField
                                            label="IFSC Code"
                                            size="small"
                                            fullWidth
                                            name="ifsc_code"
                                            placeholder="IFSC Code"
                                            value={employeeList.ifsc_code}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="col-md-3 mb-3">
                                        <TextField
                                            label="Pan Number"
                                            size="small"
                                            fullWidth
                                            name="pan_number"
                                            placeholder="Pan Number"
                                            value={employeeList.pan_number}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="col-md-3 mb-3">
                                        <TextField
                                            label="Aadhaar Number"
                                            size="small"
                                            fullWidth
                                            name="adhaar_number"
                                            placeholder="Aadhaar Number"
                                            value={employeeList.adhaar_number}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* Submit Button */}
                            <div className="text-center mt-4">
                                <Button
                                    type="submit"
                                    variant="contained"
                                    color="primary"
                                    size="large"
                                    startIcon={<SaveIcon />}
                                    sx={{ px: 5, py: 1.5 }}
                                >
                                    Update Employee
                                </Button>
                            </div>
                        </form>
                    </div>
                </div>

                {/* Credentials Popup */}
                {showCredentialsPopup && (
                    <CredentialsPopup
                        onSave={handleSaveCredentials}
                        onClose={() => setShowCredentialsPopup(false)}
                    />
                )}
            </div>
        </>
    )
}

export default EditEmployee;